window.loadScript = function(url, callback) {
  const script = document.createElement('script')
  script.type = 'text/javascript'
  if (script.readyState) {
    // only required for IE <9
    script.onreadystatechange = function() {
      if (script.readyState === 'loaded' || script.readyState === 'complete') {
        script.onreadystatechange = null
        if (callback) {
          callback()
        }
      }
    }
  } else {
    // Others
    script.onload = function() {
      if (callback) {
        callback()
      }
    }
  }

  script.src = url
  document.getElementsByTagName('head')[0].appendChild(script)
}

window._loadedScripts = []
window._loadingScripts = []

window.loadScripts = function(urls, callback) {
  if (urls && urls.length > 0) {
    const url = urls[0]
    if (window._loadingScripts.indexOf(url) >= 0) {
      setTimeout(function() {
        window.loadScripts(urls, callback)
      }, 10)
    } else if (window._loadedScripts.indexOf(url) >= 0) {
      urls.splice(0, 1)
      window.loadScripts(urls, callback)
    } else {
      window._loadingScripts.push(url)
      urls.splice(0, 1)
      window.loadScript(url, () => {
        window._loadedScripts.push(url)
        window._loadingScripts.splice(window._loadingScripts.indexOf(url), 1)
        window.loadScripts(urls, callback)
      })
    }
  } else if (callback) {
    callback()
  }
}
